import SDKConnector from '../SDKConnector';
import { CALLING_BACKEND } from '../common/types';
import log from '../Logger';
import { getCallingBackEnd } from '../common/Utils';
import { METHOD_START_MESSAGE } from '../common/constants';
import { COMMON_EVENT_KEYS } from '../Events/types';
import { Eventing } from '../Events/impl';
import { WxcCallRecordingConnector } from './WxcCallRecordingConnector';
import { CALL_RECORDING_FILE, METHODS } from './constants';
export class CallRecording extends Eventing {
    logger;
    sdkConnector;
    webex;
    callingBackend;
    backendConnector;
    constructor(webex, logger) {
        super();
        this.logger = logger;
        this.sdkConnector = SDKConnector;
        if (!this.sdkConnector.getWebex()) {
            SDKConnector.setWebex(webex);
        }
        this.webex = this.sdkConnector.getWebex();
        this.callingBackend = getCallingBackEnd(this.webex);
        this.initializeBackendConnector();
        this.forwardRecordingEvents();
        log.setLogger(logger.level, CALL_RECORDING_FILE);
    }
    initializeBackendConnector() {
        log.info(METHOD_START_MESSAGE, {
            file: CALL_RECORDING_FILE,
            method: METHODS.INITIALIZE_BACKEND_CONNECTOR,
        });
        switch (this.callingBackend) {
            case CALLING_BACKEND.WXC: {
                this.backendConnector = new WxcCallRecordingConnector(this.webex, this.logger);
                break;
            }
            default: {
                throw new Error('Calling backend is not identified, exiting....');
            }
        }
    }
    forwardRecordingEvents() {
        this.backendConnector.on(COMMON_EVENT_KEYS.CALL_RECORDING_CREATED, (event) => this.emit(COMMON_EVENT_KEYS.CALL_RECORDING_CREATED, event));
        this.backendConnector.on(COMMON_EVENT_KEYS.CALL_RECORDING_UPDATED, (event) => this.emit(COMMON_EVENT_KEYS.CALL_RECORDING_UPDATED, event));
        this.backendConnector.on(COMMON_EVENT_KEYS.CALL_RECORDING_DELETED, (event) => this.emit(COMMON_EVENT_KEYS.CALL_RECORDING_DELETED, event));
    }
    getCallRecording(request) {
        return this.backendConnector.getCallRecording(request);
    }
    async deleteRecording(recordingId, options) {
        return this.backendConnector.deleteRecording(recordingId, options);
    }
}
export const createCallRecordingClient = (webex, logger) => new CallRecording(webex, logger);
